<script>
    import { fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import fetchData from '../../api.js';
    import { systemUrl} from '../../api.js';
    import UserStore from '../../stores/user';
    import { cartsStore }  from '../../stores/cartStore';
    import fetchCarts from '../../agents.js';
    import { _ } from "svelte-i18n";

    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    export let params;

    let isLoading = false;
    let search = '';
    let products = [];
    let productsQty = {};
    let productStore = {};
    let cart = {};
    let selectedItems = {};
    let selectedColors = {};
    let selectedColorsMap = {};
    let filteredVariantsMap = {};
    let productPreviewTouchStartX = null;
    let suppressProductCardClick = false;
    let SupplierName = [];
    let model_Brand = [];
    let Type = [];
    let model_Season = [];
    let model_Collection = [];
    let model_Year = [];
    let filters = {
        model_Brand: [],
        model_Year: [],
        model_Season: [],
        Type: [],
        SupplierName: [],
        model_Collection: [],
        
    };
    const filterKeys = ['model_Brand', 'model_Year', 'model_Season', 'Type', 'SupplierName', 'model_Collection'];
    let hasInitializedUrlFilters = false;

    let previewImage = null;
    let previewImages = [];
    let previewImageIndex = 0;
    let previewTouchStartX = null;

    let selectedProductForImages = null;

    const FILTERS_STORAGE_KEY = 'agents_products_filters';

    function saveFiltersToStorage() {
        try {
            localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify({ search, filters }));
        } catch (e) {
            // ignore
        }
    }

    function loadFiltersFromStorage() {
        try {
            const raw = localStorage.getItem(FILTERS_STORAGE_KEY);
            if (!raw) return false;
            const saved = JSON.parse(raw);
            if (saved.search !== undefined) search = saved.search;
            if (saved.filters) {
                filters = { ...filters, ...saved.filters };
            }
            return true;
        } catch (e) {
            return false;
        }
    }

    function clearFiltersFromStorage() {
        try {
            localStorage.removeItem(FILTERS_STORAGE_KEY);
        } catch (e) {
            // ignore
        }
    }

    function getHashContext() {
        const url = new URL(window.location.href);
        const hashWithoutPrefix = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash;
        const [hashPath = '', hashQuery = ''] = hashWithoutPrefix.split('?');
        return {
            url,
            hashPath,
            params: new URLSearchParams(hashQuery)
        };
    }

    function applyFiltersFromUrl() {
        const { params } = getHashContext();

        const hasUrlFilters = params.get('search') || filterKeys.some(k => params.get(k));

        if (hasUrlFilters) {
            search = params.get('search') || '';
            const urlFilters = {};
            filterKeys.forEach((key) => {
                const rawValue = params.get(key) || '';
                urlFilters[key] = rawValue
                    ? rawValue.split(',').map((value) => value.trim()).filter(Boolean)
                    : [];
            });
            filters = { ...filters, ...urlFilters };
        } else {
            loadFiltersFromStorage();
        }
    }

    function syncFiltersToUrl() {
        const { url, hashPath, params } = getHashContext();

        if (search) {
            params.set('search', search);
        } else {
            params.delete('search');
        }

        filterKeys.forEach((key) => {
            const value = filters[key];
            const normalizedValue = Array.isArray(value)
                ? value.filter(Boolean)
                : (value ? [value] : []);

            if (normalizedValue.length) {
                params.set(key, normalizedValue.join(','));
            } else {
                params.delete(key);
            }
        });

        const nextQuery = params.toString();
        const nextHash = nextQuery ? `${hashPath}?${nextQuery}` : hashPath;

        if (url.hash.replace('#', '') !== nextHash) {
            window.history.replaceState({}, '', `${url.pathname}${url.search}#${nextHash}`);
        }

        saveFiltersToStorage();
    }
    

    $: selectedCartId = params?.cart_id ? params.cart_id : null;

    $: carts = $cartsStore;
        
    $: productStoresMap = products.map(product => 
        [...new Set(
            (product.variants || []).flatMap(v => 
                Object.keys(v.inventory || {})
            )
        )].sort((a, b) => Number(a) - Number(b))
    );

    $: colors = selectedProductForImages
        ? getProductColors(selectedProductForImages)
        : [];

    $: filterUrlState = [
        search,
        filters.model_Brand.join(','),
        filters.model_Year.join(','),
        filters.model_Season.join(','),
        filters.Type.join(','),
        filters.SupplierName.join(','),
        filters.model_Collection.join(',')
    ].join('||');

    $: if (hasInitializedUrlFilters && filterUrlState !== undefined) {
        syncFiltersToUrl();
    }

    function getVariantImage(color) {

        return selectedProductForImages.colorImages?.find(
        i => i.color === color
        )?.image_url;

    }

    function getProductPreviewImages(product) {
        const images = [];

        const addImage = (value) => {
            if (typeof value !== 'string') {
                return;
            }

            const cleanValue = value.trim();
            if (!cleanValue) {
                return;
            }

            images.push(cleanValue);
        };

        addImage(product?.image_url);
        addImage(product?.image);
        addImage(product?.src);
        addImage(product?.url);

        (product?.colorImages || []).forEach((img) => {
            addImage(img?.image_url);
            addImage(img?.image);
            addImage(img?.src);
            addImage(img?.url);
        });

        (product?.variants || []).forEach((variant) => {
            addImage(variant?.image_url);
            addImage(variant?.image);
            addImage(variant?.src);
            addImage(variant?.url);
        });

        return [...new Set(images)];
    }

    function getProductCardImage(product, index) {
        const images = getProductPreviewImages(product);
        if (!images.length) {
            return '';
        }

        const currentIndex = product?._previewImageIndex ?? 0;
        const normalizedIndex = ((currentIndex % images.length) + images.length) % images.length;
        return images[normalizedIndex];
    }

    function setProductCardImageIndex(index, product, nextIndex) {
        const images = getProductPreviewImages(product);
        if (images.length <= 1) {
            return;
        }

        const normalizedIndex = ((nextIndex % images.length) + images.length) % images.length;

        let targetIndex = index;

        if (!products[targetIndex] || (
            products[targetIndex]?.product_id !== product?.product_id &&
            products[targetIndex]?.sku !== product?.sku
        )) {
            targetIndex = products.findIndex((item) =>
                (item?.product_id && item?.product_id === product?.product_id)
                || (item?.sku && item?.sku === product?.sku)
            );
        }

        if (targetIndex < 0 || !products[targetIndex]) {
            return;
        }

        products[targetIndex] = {
            ...products[targetIndex],
            _previewImageIndex: normalizedIndex
        };
        products = [...products];
    }

    function showNextProductCardImage(index, product) {
        const currentIndex = product?._previewImageIndex ?? 0;
        setProductCardImageIndex(index, product, currentIndex + 1);
    }

    function showPrevProductCardImage(index, product) {
        const currentIndex = product?._previewImageIndex ?? 0;
        setProductCardImageIndex(index, product, currentIndex - 1);
    }

    function handleProductCardImageClick(event, index, product) {
        if (suppressProductCardClick) {
            suppressProductCardClick = false;
            return;
        }

        toggleVariants(index);
    }

    function handleProductCardTouchStart(event) {
        suppressProductCardClick = false;
        productPreviewTouchStartX = event.changedTouches?.[0]?.clientX ?? null;
    }

    function handleProductCardTouchEnd(event, index, product) {
        const images = getProductPreviewImages(product);
        if (productPreviewTouchStartX === null) {
            productPreviewTouchStartX = null;
            return;
        }

        const endX = event.changedTouches?.[0]?.clientX ?? productPreviewTouchStartX;
        const deltaX = endX - productPreviewTouchStartX;
        const swipeThreshold = 25;

        suppressProductCardClick = true;

        if (Math.abs(deltaX) < swipeThreshold) {
            toggleVariants(index);
            productPreviewTouchStartX = null;
            return;
        }

        if (images.length > 1) {
            const currentIndex = product?._previewImageIndex ?? 0;
            if (deltaX < 0) {
                setProductCardImageIndex(index, product, currentIndex + 1);
            } else {
                setProductCardImageIndex(index, product, currentIndex - 1);
            }
        }

        productPreviewTouchStartX = null;
    }

    function openPreview(product, imageUrl = '') {
        const images = getProductPreviewImages(product);
        if (!images.length) {
            previewImage = null;
            previewImages = [];
            previewImageIndex = 0;
            return;
        }

        previewImages = images;
        const foundIndex = imageUrl ? images.indexOf(imageUrl) : -1;
        previewImageIndex = foundIndex >= 0 ? foundIndex : 0;
        previewImage = previewImages[previewImageIndex];
    }

    function closePreview() {
        previewImage = null;
        previewImages = [];
        previewImageIndex = 0;
        previewTouchStartX = null;
    }

    function showNextPreview() {
        if (previewImages.length <= 1) {
            return;
        }
        previewImageIndex = (previewImageIndex + 1) % previewImages.length;
        previewImage = previewImages[previewImageIndex];
    }

    function showPrevPreview() {
        if (previewImages.length <= 1) {
            return;
        }
        previewImageIndex = (previewImageIndex - 1 + previewImages.length) % previewImages.length;
        previewImage = previewImages[previewImageIndex];
    }

    function onPreviewZoneClick(event) {
        if (previewImages.length <= 1) {
            closePreview();
            return;
        }

        const rect = event.currentTarget.getBoundingClientRect();
        const isLeftSide = (event.clientX - rect.left) < rect.width / 2;

        if (isLeftSide) {
            showPrevPreview();
        } else {
            showNextPreview();
        }
    }

    function onPreviewTouchStart(event) {
        previewTouchStartX = event.changedTouches?.[0]?.clientX ?? null;
    }

    function onPreviewTouchEnd(event) {
        if (previewImages.length <= 1 || previewTouchStartX === null) {
            return;
        }

        const endX = event.changedTouches?.[0]?.clientX ?? previewTouchStartX;
        const deltaX = endX - previewTouchStartX;
        const swipeThreshold = 30;

        if (Math.abs(deltaX) < swipeThreshold) {
            return;
        }

        if (deltaX < 0) {
            showNextPreview();
        } else {
            showPrevPreview();
        }
    }

    function getProductColors(product) {

        return [
            ...new Set(
                (product.variants || [])
                    .map(v => v.color)
                    .filter(Boolean)
            )
        ];
    }

    function toggleColor(productIndex, color, product) {

        if (!selectedColorsMap[productIndex]) {
            selectedColorsMap[productIndex] = [];
        }

        const selected = selectedColorsMap[productIndex];

        if (selected.includes(color)) {
            selectedColorsMap[productIndex] = selected.filter(c => c !== color);
        } else {
            selectedColorsMap[productIndex] = [...selected, color];
        }

        updateFilteredVariants(productIndex, product);
    }




    function updateFilteredVariants(productIndex, product) {

        const selected = selectedColorsMap[productIndex];

        if (!selected || selected.length === 0) {
            filteredVariantsMap[productIndex] = product.variants;
        } else {
            filteredVariantsMap[productIndex] =
                product.variants.filter(v => selected.includes(v.color));
        }

        filteredVariantsMap = { ...filteredVariantsMap };
    }


    function toggleSelection(sku, store) {
        selectedItems[sku] ??= {};
        selectedItems[sku][store] ??= { checked: false, qty: 1 };
        selectedItems[sku][store].checked = !selectedItems[sku][store].checked;
        selectedItems = { ...selectedItems };
    }

    function updateQty(sku, store, value,product) {
        selectedItems[sku] ??= {};
        selectedItems[sku][store] ??= { checked: true, qty: 1 };
        selectedItems[sku][store].qty = value;
        selectedItems = { ...selectedItems };
    }

    async function addSelectedToCart(variants, index,parent_sku) {
        for (const variant of variants) {
            const sku = variant.sku;
            for (const store in selectedItems[sku] || {}) {
                const item = selectedItems[sku][store];
                if (!item.checked) continue;
                console.log(variant)
                await addToCart(sku, store, item.qty,variant.name,variant.special_price,variant.product_id,variant.parent_id,parent_sku,variant.regular_price); // your existing function
            }        
        }

        openVariants[index] = false;

    }

    


    let openVariants = {};

    function toggleVariants(index) {
        openVariants[index] = !openVariants[index];
        openVariants = { ...openVariants };
    }

    function setQty(sku, qty) {
        productsQty[sku] = qty;

    }
    function setProductStore(sku, store) {
        productStore[sku] = store;
    }


    async function fetchCart() {

        let postData = {
            action : 'agents_get_cart',
            token : $UserStore.data,
            cart_id : selectedCartId
        }
        let response = await fetchData(postData);
        cart = response?.data || {};

        selectedItems = {};
        cart.items?.forEach(item => {
            selectedItems[item.sku] ??= {};
            selectedItems[item.sku][item.store] = {
                checked: true,
                qty: item.quantity
            };
        });

    }

    onMount(async () => {
        if (!$UserStore || !$UserStore.data) {
            push('/login');
            return;
        }

        applyFiltersFromUrl();
        hasInitializedUrlFilters = true;

        // let postData = {
        //     action : 'agents_get_carts',
        //     token : $UserStore.data
        // }
        // let response = await fetchCarts(postData);
        // carts = response?.data || {};

        searchProducts(true);
        getFiltersData();
        fetchCart();


        window.addEventListener('keydown', closeVariantsOnEsc);
        return () => {
            window.removeEventListener('keydown', closeVariantsOnEsc);
        };

    });

    function closeVariantsOnEsc(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            // Close all open variants (or just the current one)
            openVariants = {};  // simplest: close all
            // Alternative: close only the current one
            // openVariants[index] = false;
        }
    }


    async function getFiltersData() {
        isLoading = true;

        try {
            let postData = {
                action : 'agents_get_filters_data',
                token : $UserStore.data
            }

            const res = await fetchData(postData);

            model_Brand = res?.data?.model_Brand || [];
            model_Season = res?.data?.model_Season || [];
            Type = res?.data?.Type || [];
            SupplierName = res?.data?.SupplierName || [];
            model_Year = res?.data?.model_Year || [];

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }

    async function searchProducts(all=false) {
        if (!search && !all) {
            products = [];
            return;
        }

        isLoading = true;

        let postData = {
            q: search,
            filters: filters,
            action : 'agents_products_search',
            token : $UserStore.data
        }

        try {
            const res = await fetchData(postData, {
                method: 'POST',
                body: { q: search }
            });

            const parseInventory = (inventory) => {
                if (!inventory) {
                    return {};
                }

                if (typeof inventory === 'object') {
                    return inventory;
                }

                try {
                    return JSON.parse(inventory) || {};
                } catch (error) {
                    return {};
                }
            };

            const hasInventory = (inventory) => {
                if (!inventory || typeof inventory !== 'object') {
                    return false;
                }

                return Object.keys(inventory).length > 0;
            };

            // initialize qty per variant
            products = (res?.data || []).map(p => {
                if (p.variants) {
                    p.variants = p.variants.map(v => ({
                        ...v,
                        qty: 0,
                        inventory: parseInventory(v.inventory)
                    }));
                    productsQty = { ...Object.fromEntries(p.variants.map(v => [v.sku, v.qty])) ,...productsQty }}
                return p;
            }).filter((product) => {
                if (!Array.isArray(product.variants) || product.variants.length === 0) {
                    return false;
                }

                return product.variants.some((variant) => hasInventory(variant.inventory));
            });
        } catch (e) {
            console.error(e);
            products = [];
        }

        isLoading = false;
    }

    async function addToCart(sku, store, qty, name, price,product_id,parent_id,parent_sku,price_before_discount) {

        if (qty <= 0) return;

        isLoading = true;

        try {

            let postData = {
                sku,
                quantity: qty,
                store: store,
                name: name,
                price: price,
                price_before_discount: price_before_discount,
                product_id: product_id,
                parent_id: parent_id,
                parent_sku : parent_sku,
                action : 'agents_cart_add',
                token : $UserStore.data,
                cart_id : selectedCartId
            }

            const response = await fetchData(postData);

            if (response?.data?.id) {
                selectedCartId = response?.data?.id;
                cart = response.data;

            }

            if (params?.cart_id != selectedCartId) {
                push(`/agents/products/${selectedCartId}`);
            }

        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }


    async function uploadImage(e, color) {

        const file = e.target.files[0];
        if (!file) return;

        const fd = new FormData();
        fd.append('sku', selectedProductForImages.sku);
        fd.append('color', color);
        fd.append('file', file);

        let url = systemUrl + 'agents_upload_image_color?token='+ $UserStore.data;

        const res = await fetch(url, {
            method: 'POST',
            body: fd
        });

        const data = await res.json();

        if (data.success) {
            if (!selectedProductForImages.colorImages) product.colorImages = [];

            const existing = selectedProductForImages.colorImages.find(i => i.color === color);
            if (existing) {
                existing.image_url = data.image_url;
            } else {
                selectedProductForImages.colorImages.push({ color, image_url: data.image_url });
            }


            selectedProductForImages = selectedProductForImages;

            console.log(selectedProductForImages)

            products = products.map(p =>
                p.product_id === selectedProductForImages.product_id
                    ? { ...selectedProductForImages }
                    : p
            );


        }

    }

</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading} />
    <Header />

    <div class="page">
        <TopInfo />

        <div class="shipment">

            {#if previewImage}
            <div transition:fade
                class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                on:click={onPreviewZoneClick}
                on:touchstart={onPreviewTouchStart}
                on:touchend={onPreviewTouchEnd}
            >
                <div class="relative" on:click|stopPropagation>
                    
                    <!-- Close Button -->
                    <button
                        class="absolute -top-3 -right-3 bg-white rounded-full px-2 py-1 shadow"
                        on:click={closePreview}
                    >
                        ✕
                    </button>

                    <!-- Big Image -->
                    <img
                        src={previewImage}
                        class="max-w-[90vw] max-h-[90vh] object-contain rounded"
                    />

                </div>
            </div>
        {/if}

            {#if selectedProductForImages }
            <div class="fixed inset-0 bg-black/40 flex justify-center items-center z-40">

                <div class="bg-white w-full max-w-xl p-5 rounded shadow">

                    <div class="flex justify-between items-center mb-4">
                        <h2 class="font-bold text-lg">
                            {$_('agents.products.upload_images')} — {selectedProductForImages.name}
                        </h2>

                        <button on:click={() => { selectedProductForImages=null}}>✕</button>
                    </div>

                    <div class="space-y-3">

                        {#each colors as color}
                            <div class="flex items-center gap-4 border p-2 rounded">

                                <div class="w-24 text-[12px]">
                                    {color}
                                </div>

                                {#if getVariantImage(color)}
                                    <img
                                        src={getVariantImage(color)}
                                        class="w-16 h-16 object-cover rounded border cursor-pointer cursor-zoom-in"
                                        on:click={() => openPreview(selectedProductForImages, getVariantImage(color))}
                                    />
                                {:else}
                                    <div class="w-12 h-12 border flex items-center justify-center text-xs text-gray-400">
                                        {$_('agents.products.no_image')}
                                    </div>
                                {/if}

                                <input
                                    class="text-[12px]"
                                    type="file"
                                    accept="image/*"
                                    on:change={(e) => uploadImage(e, color)}
                                />
                            </div>
                        {/each}

                    </div>

                </div>

            </div>

            {/if}



            {#if selectedCartId}
                <div class="mb-4">
                    <strong>{$_('agents.cart.name')}:</strong> {carts[selectedCartId]?.customer_name || 'N/A'} ({selectedCartId}) <br>
                    <strong>{$_('agents.cart.date')}:</strong> {carts[selectedCartId]?.date_time || 'N/A'}
                </div>
            {/if}
            <h1 class="text-start">{$_('agents.products.name')}</h1>

            <!-- Search -->
            <div class="search-box">
                <input
                    type="text"
                    placeholder="{$_('agents.products.search')}"
                    bind:value={search}
                />
            </div>
            <div class="grid grid-cols-2 md:grid-cols-6 gap-2 mt-3 mb-[15px]">

                <!-- BRAND
                <select bind:value={filters.model_Brand}>
                    <option value="">{$_('agents.products.brand')}</option>
                    {#each model_Brand as brand}
                        <option value={brand}>{brand}</option>
                    {/each}
                </select> -->

                <!-- SEASON -->
                <div class="flex flex-col gap-1">
                    <div class="text-xs">{$_('agents.products.season')}</div>
                    <select multiple bind:value={filters.model_Season}>
                        {#each model_Season as s}
                            <option value={s}>{s}</option>
                        {/each}
                    </select>
                </div>

                <!-- TYPE -->
                <div class="flex flex-col gap-1">
                    <div class="text-xs">{$_('agents.products.type')}</div>
                    <select multiple bind:value={filters.Type}>
                        {#each Type as type}
                            <option value={type}>{type}</option>
                        {/each}
                    </select>
                </div>

                <!-- SUPPLIER -->
                <div class="flex flex-col gap-1">
                    <div class="text-xs">{$_('agents.products.supplier')}</div>
                    <select multiple bind:value={filters.SupplierName}>
                        {#each SupplierName as supplier}
                            <option value={supplier}>{supplier}</option>
                        {/each}
                    </select>
                </div>

                <div class="flex flex-col gap-1">
                    <div class="text-xs">{$_('agents.products.year')}</div>
                    <select multiple bind:value={filters.model_Year}>
                        {#each model_Year as year}
                            <option value={year}>{year}</option>
                        {/each}
                    </select>
                </div>

                <button
                    class="bg-gray-200 px-3 py-1 rounded"
                    on:click={() => {                    
                        syncFiltersToUrl();
                        searchProducts(true);
                    }}
                >
                    {$_('agents.products.search_button')}
                </button>

                <button
                    class="bg-gray-200 px-3 py-1 rounded"
                    on:click={() => {
                        filters = {
                            model_Brand: [],
                            model_Collection: [],
                            model_Year: [],
                            model_Season: [],
                            Type: [],
                            SupplierName: []
                        };
                        search = '';
                        clearFiltersFromStorage();
                        syncFiltersToUrl();
                        searchProducts(true);
                    }}
                >
                    {$_('agents.products.clear_filters')}
                </button>
                

            </div>

            



            <!-- Products -->
            <div class="products grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
                {#if products.length === 0 && search}
                    <p>{$_('agents.products.no_results')}</p>
                {/if}

                {#each products as product,index}
                    <div class="product border flex flex-col gap-1">
                        <div class="flex flex-col justify-between items-center cursor-pointer relative">
                            {#if selectedCartId}
                                {#each Object.keys(cart?.items || {}) as itemKey}
                                    {#if cart?.items[itemKey].product_id === product.product_id || cart?.items[itemKey].parent_id === product.product_id}
                                        <div class="absolute top-0 right-0 bg-green-600 text-white text-xs px-1 rounded-bl">
                                            {$_('agents.products.in_cart')}
                                        </div>
                                    {/if}               
                                {/each}
                            {/if}
                            <div class="flex flex-col gap-2 items-center justify-center" on:click={() => toggleVariants(index)}>
                                <div
                                    class="w-full relative"
                                    on:click|stopPropagation={(event) => handleProductCardImageClick(event, index, product)}
                                    on:touchstart|stopPropagation={handleProductCardTouchStart}
                                    on:touchend|stopPropagation={(event) => handleProductCardTouchEnd(event, index, product)}
                                >
                                    <img src="{getProductCardImage(product, index)}" class="w-full h-full object-contain">

                                    {#if getProductPreviewImages(product).length > 1}
                                        <button
                                            type="button"
                                            class="absolute left-1 top-1/2 -translate-y-1/2 bg-black/60 text-white w-6 h-6 rounded-full flex items-center justify-center"
                                            on:click|stopPropagation={() => showPrevProductCardImage(index, product)}
                                        >
                                            ›
                                        </button>
                                        <button
                                            type="button"
                                            class="absolute right-1 top-1/2 -translate-y-1/2 bg-black/60 text-white w-6 h-6 rounded-full flex items-center justify-center"
                                            on:click|stopPropagation={() => showNextProductCardImage(index, product)}
                                        >
                                            ‹                                            
                                        </button>
                                    {/if}
                                </div>
                                <div class="product-name text-[11px]">
                                    {product.name} - {product.sku}       
                                </div>
                            </div>
                            <div class="product-sku text-black font-bold flex items-center gap-2 bg-black text-white rounded px-3 py-1 cursor-pointer mb-[10px]"
                                    on:click={() => toggleVariants(index)}>
                                {openVariants[index] 
                                    ? $_('agents.products.open_variants') 
                                    : $_('agents.products.open_variants')}
                                
                                <i class="fa-solid"
                                class:fa-angle-down={!openVariants[index]}
                                class:fa-angle-up={openVariants[index]}>
                                </i>
                            </div>
                            <button 
                                class="product-sku font-bold flex items-center gap-2 bg-red-400 text-white text-[12px] rounded px-3 py-1 cursor-pointer mb-[10px]" 
                                on:click={() => selectedProductForImages = product}>{$_('agents.products.images')}</button>
                        </div>
                        <!-- Variants -->

                        {#if openVariants[index] && product.variants?.length}


                            <div class="variants fixed left-0 w-full h-full px-2 pb-2 top-0 bg-white border z-50 overflow-auto overflow-y-auto">
                                <div class="flex justify-between items-center sticky top-0 bg-white my-2">
                                    <div class="product-sku text-black font-bold flex items-center gap-2 bg-black text-white rounded px-3 py-1 cursor-pointer"
                                    on:click={() => toggleVariants(index)}>
                                        {$_('agents.products.close')}             
                                    </div>

                                    <div class="flex gap-1">
                                        {#each [...new Set(product.variants.map(v => v.color))] as color}

                                            <button
                                                class="px-3 py-1 border rounded text-sm
                                                {selectedColorsMap[index]?.includes(color)
                                                    ? 'bg-black text-white'
                                                    : 'bg-gray-100'}"

                                                on:click={() => toggleColor(index, color, product)}
                                            >
                                                {color}
                                            </button>

                                        {/each}

                                    </div>

                                    <button
                                        class="bg-red-800 text-white rounded px-5 py-1"
                                        on:click={() => addSelectedToCart(product.variants,index,product.sku)}
                                    >
                                        {$_('agents.cart.add')}
                                    </button>
                                </div>

                                <table class="w-full border mt-3 text-sm">
                                    <thead>
                                        <tr class="bg-gray-100">
                                            <th class="border p-2">SKU</th>
                                            {#each productStoresMap[index] as store}
                                                <th class="border p-2 text-center">{store}</th>
                                            {/each}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {#each filteredVariantsMap[index] || product.variants as variant}
                                            <tr>
                                                <td class="border p-2 flex gap-1">
                                                    <div class="font-small text-[12px]">{variant.color} - {variant.size}</div>
                                                    <div class="text-gray-500 text-[12px]">{variant.sku}</div>
                                                </td>

                                                {#each productStoresMap[index] as store}
                                                    <td class="border p-1 text-center">
                                                        {#if (variant.inventory?.[store] ?? 0) > 0}
                                                            <div class="flex items-center gap-1">
                                                                <input
                                                                    class="w-[15px] h-[15px]"
                                                                    type="checkbox"
                                                                    checked={selectedItems?.[variant.sku]?.[store]?.checked || false}
                                                                    on:change={() => toggleSelection(variant.sku, store)}
                                                                />
                                                                <span class="text-green-700 text-xs">{variant.inventory[store]}</span>
                                                                <input
                                                                    type="number"
                                                                    min="1"
                                                                    max={variant.inventory[store]}
                                                                    class="w-14 border rounded px-1 text-center"
                                                                    value={selectedItems?.[variant.sku]?.[store]?.qty || 0}
                                                                    on:input={(e) => updateQty(variant.sku, store, +e.target.value,product)}
                                                                />
                                                            </div>
                                                        {:else}
                                                            <span class="text-red-400">0</span>
                                                        {/if}
                                                    </td>
                                                {/each}
                                            </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </div>
                        {/if}





                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style>
    .search-box {
        margin: 15px 0;
    }





    .product-name {
        font-weight: bold;
        margin-bottom: 10px;
    }

    .variants {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .variant-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        background: #fafafa;
    }

    .variant-info {
        display: flex;
        flex-direction: column;
    }

    .variant-name {
        font-size: 14px;
    }

    .variant-sku,
    .variant-price {
        font-size: 12px;
        color: #666;
    }

    .variant-actions {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .variants input[type="number"] {
        width: 50px;
        padding: 2px;
    }


    .border {
        border: 1px solid #efefef;
    }
</style>
